module.exports = value => typeof value === 'string' && !!value.length
